<script>
	import { onDestroy, getContext } from 'svelte'
	import { adminUpdateSeasonsEntry } from '../AdminModule.svelte'
	import { slide } from 'svelte/transition'
	import { urlAdmin } from '../../../library/scripts/Setup.svelte'
	import { styles } from '../../../library/scripts/styles'
	import Shader from '../../../library/ShadersAndSpinners/Shader.svelte'
	import Alert from '../../../modals/Alert.svelte'

	const globals = getContext('globals')
	const fsX = globals.fsL
	const fsN = globals.fsN
	const fsS = globals.fsS
	const color = globals.colorMain
	const colorError = globals.colorError
	const shadow = globals.boxShadow

	let seasons
	const admUpdSeason = adminUpdateSeasonsEntry.subscribe((value) => {
		if (!value) seasons = []
		else seasons = JSON.parse(value)
	})

	//show single item
	let showItem = false
	let itemName = null

	let alertError = false
	let message = ''

	const delete_item_from_db = async (name) => {
		const deleteItem = await fetch(urlAdmin, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				cmd: 'delete_seasons_entry',
				name: name,
			}),
		})

		const dataResponse = await deleteItem.json()
		return dataResponse.fetch
	}

	const reset_error = () => {
		alertError = false
		message = ''
	}

	const delete_item = async (name) => {
		const deleteFromDb = await delete_item_from_db(name)

		if (deleteFromDb !== 0) {
			seasons = []
			deleteFromDb.forEach((item) => {
				let tmpItem = {
					name: item[0],
					start: item[1],
					end: item[2],
				}

				//add the item at the beginning of the array menu
				seasons.push(tmpItem)
			})

			adminUpdateSeasonsEntry.set(JSON.stringify(seasons))
		} else adminUpdateSeasonsEntry.set(null)
	}

	onDestroy(() => {
		admUpdSeason
	})
</script>

<div class="container">
	{#if !showItem}
		<div style="width:100%" transition:slide={{ duration: 500, delay: 600 }}>
			<div class="title" use:styles={{ fsX, color }}>SEASONS PREVIEW</div>
			<!-- no entry yet -->

			{#if seasons.length === 0 || !seasons}
				<div class="message error" use:styles={{ fsN, colorError }}>No entry yet</div>
			{:else}
				{#each seasons as item}
					<div class="item_grid" use:styles={{ fsN, color }}>
						<div>{item.name}</div>
						<div class="align_right">{item.start}</div>
						<div>-</div>
						<div>{item.end}</div>
						<div class="link" on:click={() => delete_item(item.name)} on:keydown={() => delete_item(item.name)} />
					</div>
				{/each}
				<div class="spacer" />
			{/if}
		</div>
	{/if}
</div>

{#if alertError}
	<Shader>
		<div slot="content">
			<Alert {message} showOkButton={false} alertMessage="ERROR" on:alertclose={reset_error} />
		</div>
	</Shader>
{/if}

<style>
	.container {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: flex-start;
		margin-left: 5%;
		width: 90%;
		cursor: default;
		user-select: none;
	}
	.title {
		font-size: var(--fsX);
		font-weight: bold;
		color: var(--color);
		margin: 30px 0 20px 0;
	}

	.item_grid {
		display: grid;
		width: 90%;
		grid-template-columns: 45% 24% 2% 24% 5%;
		font-size: var(--fsN);
		grid-gap: 2%;
		color: var(--color);
		cursor: default;
		user-select: none;
	}

	.link {
		cursor: pointer;
		width: 25px;
		height: 25px;
		background-repeat: no-repeat;
		background-size: cover;
	}
	.link {
		background-image: url('/images/bin.png');
	}

	.align_right {
		justify-self: end;
	}

	.spacer {
		min-height: 1.5vh;
	}

	.message {
		font-size: var(--fsN);
	}

	.error {
		color: var(--colorError);
	}
</style>
